const DATA_URL_BASE64 = ';base64,'

function extractBase64Payload(data, mimeType) {
    if (typeof data !== 'string') {
        return { mimeType, base64: '' }
    }

    if (data.startsWith('data:') && data.includes(DATA_URL_BASE64)) {
        const mimeEnd = data.indexOf(DATA_URL_BASE64)
        const inferredMimeType = data.substring(5, mimeEnd)
        const base64 = data.substring(mimeEnd + DATA_URL_BASE64.length)
        return {
            mimeType: inferredMimeType || mimeType || 'application/octet-stream',
            base64,
        }
    }

    return {
        mimeType: mimeType || 'application/octet-stream',
        base64: data,
    }
}

function base64ToBytes(base64) {
    const decoded = atob(base64)
    const bytes = new Uint8Array(decoded.length)

    for (let i = 0; i < decoded.length; i++) {
        bytes[i] = decoded.charCodeAt(i)
    }

    return bytes
}

function triggerDownload(url, fileName) {
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = fileName || 'document'
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
}

function openInNewTab(url, previewWindow) {
    if (previewWindow && !previewWindow.closed) {
        try {
            previewWindow.location = url
            previewWindow.focus()
            return true
        } catch {
            return false
        }
    }

    const popup = window.open(url, '_blank')
    return !!popup
}

export function openDocument(data, mimeType, fileName, previewWindow = null) {
    const payload = extractBase64Payload(data, mimeType)
    const bytes = base64ToBytes(payload.base64)
    const blob = new Blob([bytes], { type: payload.mimeType })
    const fileURL = URL.createObjectURL(blob)

    const opened = openInNewTab(fileURL, previewWindow)
    if (!opened) {
        triggerDownload(fileURL, fileName)
    }

    // Keep the object URL alive long enough for the new tab/viewer to read it.
    window.setTimeout(() => URL.revokeObjectURL(fileURL), 60_000)
}
